module.exports = __webpack_public_path__ + "img/delete-grey24.4c873592.svg";